<div class="row g-4" *ngIf="isLoading; else metricCards">
  <div class="col-md-4" *ngFor="let _ of skeletonItems">
    <div class="widget-stat card">
      <div class="card-body p-4">
        <div class="media ai-icon">
          <span class="skeleton skeleton-icon me-3"></span>
          <div class="media-body w-100">
            <div class="skeleton skeleton-text skeleton-title mb-3"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #metricCards>
  <div class="row g-4">
    <div *ngFor="let card of cards" class="col-md-4">
      <div class="widget-stat card">
        <div class="card-body p-4">
          <div class="media ai-icon">
            <span class="me-3 bgl-{{ card.color }} text-{{ card.color }}">
              <mat-icon
                aria-hidden="false"
                aria-label="metric card icon"
                [fontIcon]="card.matIcon"
              ></mat-icon>
            </span>
            <div class="media-body">
              <p class="mb-1">{{ card.title }}</p>
              <h4 class="mb-0 me-1">{{ card.rank }}</h4>
              <span class="badge badge-{{ card.color }}" *ngIf="card.badge">
                {{ card.badge }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
